export const endpoints = {
  login: '/login',
  getPermissions: '/user/:userId/permissions',
}
